import React, { useState, useEffect, useCallback, useContext } from "react"
import styled from "styled-components"
import { Link } from "gatsby"

import {
  Container,
  TopRippedHeader,
  H1,
  ButtonLink,
  AbsoluteImg,
} from "../general/GeneralStyles"

import AppContext from "../../context/AppContext"
import { log } from "util"

const Header = styled(TopRippedHeader)`
  padding: 100px 0 140px 0;
  @media (max-width: 1400px) {
    ${AbsoluteImg} {
      display: none;
    }
  }
`

const UserInfo = styled(Container)`
  display: grid;
  grid-template-columns: 3fr 2fr;

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    grid-template-columns: 1fr;
    grid-gap: 80px;
  }

  use {
    background: #000;
    fill: red;
  }

  > div {
    text-align: left;
  }

  ${H1} {
    text-align: left;
    margin-bottom: 5px;
  }

  p {
    max-width: 600px;
  }
`

const PointsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-left: 170px !important;
  position: relative;
  z-index: 1;

  @media (max-width: ${props => props.theme.mediumBreakpoint}) {
    margin-left: auto !important;
    margin: 0 auto;
  }

  span {
    color: ${props => props.theme.primaryFont};
    font-family: ${props => props.theme.secondaryFont};
    font-size: 28px;
    font-weight: 500;
    line-height: 32px;
    text-align: right;
    display: inline-block;
    max-width: 150px;
    text-align: center;
  }

  a {
    color: ${props => props.theme.primaryColor};
    font-family: ${props => props.theme.primaryFont};
    text-decoration: none;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    text-align: right;
  }

  img {
    z-index: -1;

    position: absolute;
    top: 30px;
    left: 50%;
    transform: translate(-40%) scale(2.5);
    width: 75%;

    @media (max-width: ${props => props.theme.mediumBreakpoint}) {
      width: 100vw;
      right: -120px;
    }
  }

  > div:nth-child(1) {
    margin-right: 30px;
  }

  > div {
    display: flex;
    flex-direction: column;
  }

  h2 {
    margin-bottom: 0px;
    color: ${props => props.theme.primaryTextColor};
    font-family: ${props => props.theme.secondaryFont};
    font-size: 88px;
    font-weight: 900;
    line-height: 95px;
  }

  h3 {
    color: ${props => props.theme.primaryTextColor};
    font-family: ${props => props.theme.secondaryFont};
    font-size: 48px;
    font-weight: bold;

    line-height: 52px;
    text-align: center;
  }
`

const Pencil = styled(AbsoluteImg)`
  right: 0;
  top: 0;
  transform: rotate(90deg);
  z-index: 100;
`

const RedClay = styled(AbsoluteImg)`
  left: 0;
  top: 100px;
`

const YellowClay = styled(AbsoluteImg)`
  left: 0;
  top: 170px;
  transform: rotate(180deg);
`

const PrintButton = styled(ButtonLink)`
  position: relative;
  width: 300px;

  &::before {
    content: url("/images/icons/fax.svg");
    left: 15px;
    z-index: 11;
    top: 50%;
    transform: translate(0%, -40%);
    vertical-align: middle;
    position: absolute;
  }
`

const Dashboard = props => {
  const appContext = useContext(AppContext)
  
  return (
    <Header>
      {appContext.state && typeof appContext.state.user.user != "undefined" ? (
        <>
          <Pencil src="/images/absolute/pencils.png" />
          <RedClay src="/images/absolute/red-clay.png" />
          <YellowClay src="/images/absolute/yellow-clay.png" />
          <UserInfo>
            <div>
              <H1>Welcome {appContext.state.user.user.name || ""}</H1>
              <p>
                Once you’ve banked enough points, you’ll be able to start
                redeeming those points for free school and art supplies.
              </p>
              <PrintButton href="#">Print Mailing Form</PrintButton>
            </div>
            <PointsContainer>
              <div>
                <span>{appContext.state.user.user.home_street1 || ""}</span>
              </div>
              <div>
                <h2>{appContext.state.user.user.points || 0}</h2>
                <h3>Points</h3>
                <img src="/images/bg/paint_smudge.png" alt="" />
              </div>
            </PointsContainer>
          </UserInfo>
        </>
      ) : null}
    </Header>
  )
}

export default Dashboard
